import { useEffect, useState } from "react";
import { getPermissions, PermissionGroup } from "../permissions";
import { getApiErrorMessage } from "../../lib";

type UsePermissionsState = {
  permissionGroups: PermissionGroup[];
  isLoading: boolean;
  error: string | null;
};

export const usePermissions = () => {
  const [state, setState] = useState<UsePermissionsState>({
    permissionGroups: [],
    isLoading: true,
    error: null,
  });

  useEffect(() => {
    let isMounted = true;

    const run = async () => {
      setState((prev) => ({ ...prev, isLoading: true, error: null }));
      try {
        const permissionGroups = await getPermissions();
        if (!isMounted) return;
        setState({ permissionGroups, isLoading: false, error: null });
      } catch (error) {
        if (!isMounted) return;
        const message = getApiErrorMessage(error, "Unable to load permissions");
        setState({ permissionGroups: [], isLoading: false, error: message });
      }
    };

    run();

    return () => {
      isMounted = false;
    };
  }, []);

  return state;
};
